import React from "react";
import { Helmet } from "react-helmet-async";

const SITE_NAME = "Elite Performance Through Breath";
const DEFAULT_TITLE = "Elite Performance Through Breath — Academy";
const DEFAULT_DESCRIPTION =
  "Nervous system control for performance. Structured breathwork for executives, athletes, and high-performing teams.";
const DEFAULT_IMAGE =
  "https://customer-assets.emergentagent.com/job_breathwork-elite/artifacts/sv3jydix_EGBW%20Logo%20100%20x%2084mm%20%281%29.png";
const SITE_URL = "https://academy.evangill.xyz";

/**
 * Reusable meta tags component. Client-side updates for browser tabs, Google (which
 * renders JS), and JS-executing embed tools (Discord, some Slack unfurls).
 *
 * NOTE: LinkedIn / Facebook / iMessage crawlers do NOT execute JavaScript. For
 * article-specific previews on those platforms, use static tags in public/index.html
 * or add SSR / a prerender service later.
 */
export default function PageMeta({
  title,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  url,
  type = "website",
}) {
  const fullTitle = title ? `${title} · ${SITE_NAME}` : DEFAULT_TITLE;
  const canonical = url || (typeof window !== "undefined" ? window.location.href : SITE_URL);
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
